import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthentificationGuard } from './authetification.guard';

import { FeedResolver } from './feed.resolver';
import { UserResolver } from '../admin/user.resolver';
import { DashboardResolver } from './dashboard.resolver';
import { WorkspaceResolver } from './workspace.resolver';
import { AuthentificationResolver } from './authetification.resolver';

import { HomeComponent } from './containers/home/home.component';
import { FeedComponent } from './containers/feed/feed.component';
import { FeedsComponent } from './containers/feeds/feeds.component';
import { AlertsComponent } from './containers/alerts/alerts.component';
import { AnalyticsComponent } from './containers/analytics/analytics.component';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { DashboardsComponent } from './containers/dashboards/dashboards.component';
import { DimensionsComponent } from './containers/dimensions/dimensions.component';
import { DashboardPageComponent } from './containers/dashboard/dashboard-page.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { WorkspaceComponent } from './containers/workspace/workspace/workspace.component';
import { AlertsCenterComponent } from './containers/alerts-center/alerts-center.component';
import { NotificationsComponent } from './containers/notifications/notifications.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { ExportSchedulesComponent } from './containers/export-schedules/export-schedules.component';
import { AutoStoryRunsComponent } from './containers/auto-story-runs/auto-story-runs.component';
import { ContextualNotFoundComponent } from '../shared/components/contextual-not-found/contextual-not-found.component';

const routes: Routes = [
  {
    path: '',
    resolve: {
      user: AuthentificationResolver,
    },
    data: {
      section: 'analytics',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'analytics',
      },
      {
        path: 'analytics',
        canLoad: [AuthentificationGuard],
        component: AnalyticsComponent,
        data: {
          breadcrumb: 'breadcrumb.anlytics.analytics',
          breadcrumbIcon: ['fas', 'chart-line'],
          pageTitle: 'page-title.anlytics.analytics',
        },
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'welcome',
            canLoad: [AuthentificationGuard],
            component: WelcomeScreenComponent,
          },
          {
            path: 'home',
            canLoad: [AuthentificationGuard],
            component: HomeComponent,
            data: {
              // breadcrumb: 'breadcrumb.anlytics.home',
              // breadcrumbIcon: ['fas', 'home'],
            },
          },
          {
            path: 'user/:userId',
            canLoad: [AuthentificationGuard],
            component: UserProfileComponent,
            resolve: {
              user: UserResolver,
            },
          },
          {
            path: 'feeds',
            canLoad: [AuthentificationGuard],
            component: FeedsComponent,

            data: {
              breadcrumb: 'breadcrumb.analytics.feeds',
              breadcrumbIcon: ['fas', 'rss'],
              breadcrumbContext: 'feeds',
              pageTitle: 'page-title.analytics.feeds',
            },
          },
          {
            path: 'dimensions',
            canLoad: [AuthentificationGuard],
            component: DimensionsComponent,

            data: {
              breadcrumb: 'breadcrumb.analytics.dimensions',
              breadcrumbIcon: ['fas', 'rss'],
              breadcrumbContext: 'dimensions',
              pageTitle: 'page-title.analytics.dimensions',
            },
          },
          {
            path: 'dashboards',
            canLoad: [AuthentificationGuard],
            component: DashboardsComponent,

            data: {
              breadcrumbContext: 'dashboards',
              breadcrumb: 'breadcrumb.analytics.dashboards',
              breadcrumbIcon: ['fas', 'tachometer-alt'],
              pageTitle: 'page-title.analytics.dashboards',
            },
          },
          {
            path: 'alerts',
            canLoad: [AuthentificationGuard],
            component: AlertsComponent,

            data: {
              breadcrumbContext: 'alerts',
              breadcrumb: 'breadcrumb.analytics.alerts',
              breadcrumbIcon: ['fas', 'bell'],
              pageTitle: 'page-title.analytics.alerts',
            },
          },
          {
            path: 'home/:tab',
            canLoad: [AuthentificationGuard],
            component: HomeComponent,
            data: {},
          },
          {
            path: 'schedules',
            canLoad: [AuthentificationGuard],
            component: ExportSchedulesComponent,
            data: {
              breadcrumbContext: 'schedules',
              breadcrumb: 'breadcrumb.analytics.schedules',
              breadcrumbIcon: ['fas', 'calendar-days'],
              pageTitle: 'page-title.analytics.schedules',
            },
          },
          {
            path: 'auto-story-runs',
            canLoad: [AuthentificationGuard],
            component: AutoStoryRunsComponent,
            data: {
              breadcrumbContext: 'auto-story-runs',
              breadcrumb: 'breadcrumb.analytics.auto-story-runs',
              breadcrumbIcon: ['fas', 'wand-magic-sparkles'],
              pageTitle: 'page-title.analytics.auto-story-runs',
            },
          },
          {
            path: 'notifications',
            canLoad: [AuthentificationGuard],
            component: NotificationsComponent,
            data: {
              breadcrumb: 'breadcrumb.notifications.my-notifications',
              breadcrumbIcon: ['fas', 'bell'],
              pageTitle: 'page-title.analytics.my-notifications',
            },
          },
          {
            path: 'alerts-center',
            canLoad: [AuthentificationGuard],
            component: AlertsCenterComponent,
            data: {
              breadcrumb: 'breadcrumb.notifications.my-alerts',
              breadcrumbIcon: ['fas', 'bell'],
              pageTitle: 'page-title.analytics.my-alerts',
            },
          },
          {
            path: 'workspace/:workspaceId',
            canLoad: [AuthentificationGuard],
            component: WorkspaceComponent,
            data: { breadcrumbContext: 'workspace' },
            resolve: {
              workspace: WorkspaceResolver,
            },
          },
          {
            path: 'workspace/:workspaceId/:tab',
            canLoad: [AuthentificationGuard],
            component: WorkspaceComponent,
            data: { breadcrumbContext: 'workspace' },

            resolve: {
              workspace: WorkspaceResolver,
            },
          },
          {
            path: 'workspace/:workspaceId/feed/:feedId',
            canLoad: [AuthentificationGuard],
            component: FeedComponent,
            data: {},
            resolve: {
              feed: FeedResolver,
              workspace: WorkspaceResolver,
            },
          },
          {
            path: 'workspace/:workspaceId/dashboard/:dashboardId',
            canLoad: [AuthentificationGuard],
            component: DashboardComponent,
            data: {},
            resolve: {
              workspace: WorkspaceResolver,
              dashboard: DashboardResolver,
            },
            children: [
              {
                path: 'page/:pageId',
                component: DashboardPageComponent,
              },
              {
                path: '',
                component: DashboardPageComponent,
              },
            ],
          },
          {
            path: 'workspace/:workspaceId/dashboard/:dashboardId/feed/:feedId',
            canLoad: [AuthentificationGuard],
            component: FeedComponent,
            data: {},
            resolve: {
              workspace: WorkspaceResolver,
              dashboard: DashboardResolver,
              feed: FeedResolver,
            },
          },

          { path: '**', component: ContextualNotFoundComponent },
        ],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
